import React, { useState, useEffect } from 'react'
import {
	Card,
	CardHeader,
	CardContent,
	Typography,
	makeStyles,
	Button,
} from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { useTheme } from '@material-ui/core/styles'
import { useLocation } from 'react-router-dom'
import { api } from '../../services/api'
import moment from 'moment'
import EditNoteDialog from '../Dialogs/Visit/EditNoteDialog'
import { gray, purple } from '../../utils/colors'
import NotesTable from './NotesTable'

const useStyles = makeStyles((theme) => ({
	card: {
		backgroundColor: gray[100],
		boxShadow: 'none',
		border: `1px solid ${gray[400]}`,
		borderWidth: 1
	},
	header: {
		padding: '13px 24px',
		'& .MuiCardHeader-action': {
			margin: 0
		},
		'& .MuiCardHeader-title': {
			textTransform: 'none'
		}
	},
	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest
		}),
		padding: 0
	},
	expandOpen: {
		transform: 'rotate(180deg)'
	}
}))

const StaffNotesVisit = (props) => {
	const { pet, visit } = props

	const theme = useTheme()
	const classes = useStyles(theme)
	const dispatch = useDispatch()
	const location = useLocation()

	const [loading, setLoading] = useState(false)
	const [note, setStaffNote] = useState(null)
	const [shown, setDialogShown] = useState(null)
	const [staff_notes, setStaffNotes] = useState(null)

	const saveNote = async (n) => {
		try {
			let { data } = await api.put(`/updateStaffNote`, n)
			// console.log("data...", data);
			if (!n._id) {
				dispatch({ type: 'ADD_NOTE', payload: data })
			} else {
				dispatch({ type: 'UPDATE_NOTE', payload: data })
			}

			setStaffNote(null)
			setDialogShown(false)
			setLoading(false)
		} catch (e) {
			console.log('error...', e)
			setLoading(false)
		}
	}

	useEffect(() => {
		if (visit && visit.staff_notes) {
			let sn = visit.staff_notes
				.filter((n) => n.pet_id === pet._id)
				.sort((a, b) => {
					if (a.tags && a.tags.includes('raise_alert') && (!b.tags || !b.tags.includes('raise_alert')))
						return -1
					if ((!a.tags || !a.tags.includes('raise_alert')) && b.tags && b.tags.includes('raise_alert'))
						return 1
					return moment(b.createdAt).toDate() - moment(a.createdAt).toDate()
				})
			setStaffNotes(sn)
		}
	}, [visit])

	useEffect(() => {
		if (
			location &&
			shown !== false &&
			location.search &&
			location.search.includes('noteID') &&
			staff_notes &&
			!note
		) {
			let id = location.search.replace('?noteID=', '')
			let ourNote = staff_notes.find((n) => n._id === id)
			if (ourNote) setStaffNote(ourNote)
		}
	}, [location, staff_notes])

	return (
		<Card className={classes.card}>
			<CardHeader
				className={classes.header}
				title="Staff Notes"
				action={
					<Button
						onClick={() =>
							setStaffNote({
								pet_id: pet._id,
								visit_id: visit._id,
								status: 'Open',
								tags: [],
								notes: ''
							})
						}
						style={{ padding: 0 }}>
						<Typography
							style={{
								color: purple[500],
								fontSize: 16,
								textTransform: 'capitalize'
							}}>
							Add Note
						</Typography>
					</Button>
				}
			/>
			<CardContent>
				<NotesTable staff_notes={staff_notes} setStaffNote={setStaffNote} />
			</CardContent>
			<EditNoteDialog
				isShown={note ? true : false}
				setIsShown={() => {
					setStaffNote(null)
					setDialogShown(false)
				}}
				pet={pet}
				note={note}
				visit={visit}
				saveNote={saveNote}
				loading={loading}
			/>
		</Card>
	)
}

export default StaffNotesVisit
